export default [
	{
		path: '/login',
		name: 'Login',
		component: require('../pages/login.vue').default
    }
]


// WEBPACK FOOTER //
// ./src/router/notLogged.js